document.addEventListener("DOMContentLoaded", function() {
    let navAll = document.querySelectorAll('.nav-level__item');
    let infosBlockAll = document.querySelectorAll('.infos-block');

    window.choiceYourCategory = function(e){
        e = e || window.event;
        let target = e.target;

        let sectionName = target.getAttribute('data-id');

        for(let i =0;i < navAll.length;i++){
            navAll[i].classList.remove('active');
        }

        for(let i =0;i < infosBlockAll.length;i++){
            infosBlockAll[i].classList.remove('show-block');
        }

        target.classList.add('active');

        document.querySelector('#' + sectionName).classList.add('show-block');
    }

    const sizes = {
        "tabBras":[
            {"bustCircumference":"63-67", "cup":"A", "sizeFR":"80","chestSize":"77-79"},
            {"bustCircumference":"63-67", "cup":"B", "sizeFR":"80","chestSize":"79-81"},
            {"bustCircumference":"63-67", "cup":"C", "sizeFR":"80","chestSize":"81-83"},
            {"bustCircumference":"63-67", "cup":"D", "sizeFR":"80","chestSize":"83-85"},
            {"bustCircumference":"63-67", "cup":"E", "sizeFR":"80","chestSize":"85-87"},
            {"bustCircumference":"63-67", "cup":"F", "sizeFR":"80","chestSize":"87-89"},
            {"bustCircumference":"68-72", "cup":"A", "sizeFR":"85","chestSize":"82-84"},
            {"bustCircumference":"68-72", "cup":"B", "sizeFR":"85","chestSize":"84-86"},
            {"bustCircumference":"68-72", "cup":"C", "sizeFR":"85","chestSize":"86-88"},
            {"bustCircumference":"68-72", "cup":"D", "sizeFR":"85","chestSize":"88-90"},
            {"bustCircumference":"68-72", "cup":"E", "sizeFR":"85","chestSize":"90-92"},
            {"bustCircumference":"68-72", "cup":"F", "sizeFR":"85","chestSize":"92-94"},
            {"bustCircumference":"73-77", "cup":"A", "sizeFR":"90","chestSize":"87-89"},
            {"bustCircumference":"73-77", "cup":"B", "sizeFR":"90","chestSize":"89-91"},
            {"bustCircumference":"73-77", "cup":"C", "sizeFR":"90","chestSize":"91-93"},
            {"bustCircumference":"73-77", "cup":"D", "sizeFR":"90","chestSize":"93-95"},
            {"bustCircumference":"73-77", "cup":"E", "sizeFR":"90","chestSize":"95-97"},
            {"bustCircumference":"73-77", "cup":"F", "sizeFR":"90","chestSize":"97-99"},
            {"bustCircumference":"78-82", "cup":"A", "sizeFR":"95","chestSize":"92-94"},
            {"bustCircumference":"78-82", "cup":"B", "sizeFR":"95","chestSize":"94-96"},
            {"bustCircumference":"78-82", "cup":"C", "sizeFR":"95","chestSize":"96-98"},
            {"bustCircumference":"78-82", "cup":"D", "sizeFR":"95","chestSize":"98-100"},
            {"bustCircumference":"78-82", "cup":"E", "sizeFR":"95","chestSize":"100-102"},
            {"bustCircumference":"78-82", "cup":"F", "sizeFR":"95","chestSize":"102-104"},
            {"bustCircumference":"83-87", "cup":"A", "sizeFR":"100","chestSize":"97-99"},
            {"bustCircumference":"83-87", "cup":"B", "sizeFR":"100","chestSize":"99-101"},
            {"bustCircumference":"83-87", "cup":"C", "sizeFR":"100","chestSize":"101-103"},
            {"bustCircumference":"83-87", "cup":"D", "sizeFR":"100","chestSize":"103-105"},
            {"bustCircumference":"83-87", "cup":"E", "sizeFR":"100","chestSize":"105-107"},
            {"bustCircumference":"83-87", "cup":"F", "sizeFR":"100","chestSize":"107-109"},
            {"bustCircumference":"88-92", "cup":"A", "sizeFR":"105","chestSize":"102-104"},
            {"bustCircumference":"88-92", "cup":"B", "sizeFR":"105","chestSize":"104-106"},
            {"bustCircumference":"88-92", "cup":"C", "sizeFR":"105","chestSize":"106-108"},
            {"bustCircumference":"88-92", "cup":"D", "sizeFR":"105","chestSize":"108-110"},
            {"bustCircumference":"88-92", "cup":"E", "sizeFR":"105","chestSize":"110-112"},
            {"bustCircumference":"88-92", "cup":"F", "sizeFR":"105","chestSize":"112-114"},
            {"bustCircumference":"93-97", "cup":"A", "sizeFR":"110","chestSize":"107-109"},
            {"bustCircumference":"93-97", "cup":"B", "sizeFR":"110","chestSize":"109-111"},
            {"bustCircumference":"93-97", "cup":"C", "sizeFR":"110","chestSize":"111-113"},
            {"bustCircumference":"93-97", "cup":"D", "sizeFR":"110","chestSize":"113-115"},
            {"bustCircumference":"93-97", "cup":"E", "sizeFR":"110","chestSize":"115-117"},
            {"bustCircumference":"93-97", "cup":"F", "sizeFR":"110","chestSize":"117-119"},
            {"bustCircumference":"98-102", "cup":"A", "sizeFR":"115","chestSize":"112-114"},
            {"bustCircumference":"98-102", "cup":"B", "sizeFR":"115","chestSize":"114-116"},
            {"bustCircumference":"98-102", "cup":"C", "sizeFR":"115","chestSize":"116-118"},
            {"bustCircumference":"98-102", "cup":"D", "sizeFR":"115","chestSize":"118-120"},
            {"bustCircumference":"98-102", "cup":"E", "sizeFR":"115","chestSize":"120-122"},
            {"bustCircumference":"98-102", "cup":"F", "sizeFR":"115","chestSize":"122-124"},
            {"bustCircumference":"103-107", "cup":"A", "sizeFR":"120","chestSize":"117-119"},
            {"bustCircumference":"103-107", "cup":"B", "sizeFR":"120","chestSize":"119-121"},
            {"bustCircumference":"103-107", "cup":"C", "sizeFR":"120","chestSize":"121-123"},
            {"bustCircumference":"103-107", "cup":"D", "sizeFR":"120","chestSize":"123-125"},
            {"bustCircumference":"103-107", "cup":"E", "sizeFR":"120","chestSize":"125-127"},
            {"bustCircumference":"103-107", "cup":"F", "sizeFR":"120","chestSize":"127-129"}
        ],
        "tabKnickers":[
            {"basinCircumference":"86-90", "sizeUK":"(XS)", "sizeFR":"38","waistSize":"62-66"},
            {"basinCircumference":"91-95", "sizeUK":"(S)", "sizeFR":"40","waistSize":"67-71"},
            {"basinCircumference":"96-100", "sizeUK":"(M)", "sizeFR":"42","waistSize":"72-76"},
            {"basinCircumference":"101-105", "sizeUK":"(L)", "sizeFR":"44","waistSize":"77-81"},
            {"basinCircumference":"106-110", "sizeUK":"(XL)", "sizeFR":"46","waistSize":"82-86"},
            {"basinCircumference":"111-115", "sizeUK":"(2XL)", "sizeFR":"48","waistSize":"87-91"},
            {"basinCircumference":"116-120", "sizeUK":"(3XL)", "sizeFR":"50","waistSize":"92-96"},
            {"basinCircumference":"121-125", "sizeUK":"(4XL)", "sizeFR":"52","waistSize":"97-101"},
            {"basinCircumference":"126-130", "sizeUK":"(5XL)", "sizeFR":"54","waistSize":"102-106"},
            {"basinCircumference":"131-135", "sizeUK":"(6XL)", "sizeFR":"56","waistSize":"107-111"}
        ]
    };

    let resultsSizeBras = document.querySelector('#results-bras');
    let resultsSizeKnickers = document.querySelector('#results-knickers');
    let chestSize = document.querySelector('#chest-size');
    let bustCircumference = document.querySelector('#bust-circumference');
    let waistSize = document.querySelector('#waist-size');
    let basinCircumference = document.querySelector('#basin-circumference');

    window.createOption = function(value,domElem){
        let tmp = document.createElement('option');
        tmp.setAttribute('value', value);
        tmp.text = value;
        domElem.appendChild(tmp);
    }

    window.resetOption = function(domElem){
       var i, L = domElem.options.length - 1;
       for(i = L; i >= 0; i--) {
          domElem.remove(i);
       }
    }

    window.results = function(size,cup,domElem){
        domElem.textContent = size + " " + cup;
    }

    window.resetResults = function(domElem){
        domElem.textContent = "---";
    }

    chestSize.addEventListener('change', function () {
        let currentChest = this.value;
        let currentBust = bustCircumference.value;
        let resultCup, resultSizeFR;

        for(let i=0; i < sizes.tabBras.length; i++){
            if(currentChest !== "undefined" && sizes.tabBras[i].chestSize == currentChest && sizes.tabBras[i].bustCircumference == currentBust){
                resultCup = sizes.tabBras[i].cup;
                resultSizeFR = sizes.tabBras[i].sizeFR;
            } else{
                resetResults(resultsSizeBras);
            }
        }

        if(resultSizeFR !== "undefined" && resultCup !== "undefined"){
            results(resultSizeFR,resultCup,resultsSizeBras);
        }
    });

    bustCircumference.addEventListener('change', function () {
        let currentBust = this.value;
        let resultCup, resultSizeFR;
        resetOption(chestSize);

        for(let i=0; i < sizes.tabBras.length; i++){
            if(currentBust !== "undefined" && sizes.tabBras[i].bustCircumference == currentBust){
                createOption(sizes.tabBras[i].chestSize, chestSize);
                let currentChest = chestSize.value;
                if(sizes.tabBras[i].chestSize == currentChest){
                    resultCup = sizes.tabBras[i].cup;
                    resultSizeFR = sizes.tabBras[i].sizeFR;
                }
            }
        }

        if(resultSizeFR !== undefined && resultCup !== undefined){
            results(resultSizeFR,resultCup,resultsSizeBras);
        } else{
            resetResults(resultsSizeBras);
        }

    });

    // waistSize.addEventListener('change', function () {
    //     let currentWaist = this.value;
    //     let resultSizeUK, resultSizeFR;
    //     resetOption(basinCircumference);

    //     for(let i=0; i < sizes.tabKnickers.length; i++){
    //         if(currentWaist !== "undefined" && sizes.tabKnickers[i].waistSize == currentWaist){
    //             createOption(sizes.tabKnickers[i].basinCircumference, basinCircumference);
    //             let currentBasin = basinCircumference.value;
    //             if(sizes.tabKnickers[i].basinCircumference == currentBasin){
    //                 resultSizeUK = sizes.tabKnickers[i].sizeUK;
    //                 resultSizeFR = sizes.tabKnickers[i].sizeFR;
    //             }
    //         }
    //     }

    //     if(resultSizeFR !== undefined && resultSizeUK !== undefined){
    //         results(resultSizeFR,resultSizeUK,resultsSizeKnickers);
    //     }else{
    //         resetResults(resultsSizeKnickers);
    //     }
    // });

    waistSize.addEventListener('change', function () {
        let currentWaist = this.value;
        let resultSizeUK, resultSizeFR;

        for(let i=0; i < sizes.tabKnickers.length; i++){
            if(currentWaist !== "undefined" && sizes.tabKnickers[i].waistSize == currentWaist){
                let currentBasin = sizes.tabKnickers[i].basinCircumference;
                basinCircumference.value = currentBasin;
                if(sizes.tabKnickers[i].basinCircumference == currentBasin){
                    resultSizeUK = sizes.tabKnickers[i].sizeUK;
                    resultSizeFR = sizes.tabKnickers[i].sizeFR;
                }
            }
        }

        if(resultSizeFR !== undefined && resultSizeUK !== undefined){
            results(resultSizeFR,resultSizeUK,resultsSizeKnickers);
        }else{
            resetResults(resultsSizeKnickers);
        }
    });

    basinCircumference.addEventListener('change', function () {
        let currentBasin = this.value;
        let resultSizeUK, resultSizeFR;

        for(let i=0; i < sizes.tabKnickers.length; i++){
            if(currentBasin !== "undefined" && sizes.tabKnickers[i].basinCircumference == currentBasin){
                let currentWaist = sizes.tabKnickers[i].waistSize;
                waistSize.value = currentWaist;
                if(sizes.tabKnickers[i].waistSize == currentWaist){
                    resultSizeUK = sizes.tabKnickers[i].sizeUK;
                    resultSizeFR = sizes.tabKnickers[i].sizeFR;
                }
            }
        }

        if(resultSizeFR !== undefined && resultSizeUK !== undefined){
            results(resultSizeFR,resultSizeUK,resultsSizeKnickers);
        }else{
            resetResults(resultsSizeKnickers);
        }
    });

    let slideUp = (target, duration=500) => {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout( () => {
          target.style.display = 'none';
          target.style.removeProperty('height');
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
        }, duration);
      }

      let slideDown = (target, duration=500) => {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
          display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout( () => {
          target.style.removeProperty('height');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
        }, duration);
      }
       let slideToggle = (target, duration = 500) => {
        target.parentNode.querySelector('.chevron-right').classList.toggle('rotate');
        if (window.getComputedStyle(target).display === 'none') {
          return slideDown(target, duration);

        } else {
          return slideUp(target, duration);
        }
      }

    let speedAnimation = 400;

    let slideBtnClick = (id, sl, targetId) => document.getElementById(id).addEventListener('click', () => sl(targetId, speedAnimation));

    slideBtnClick('slideBras', slideToggle, showTabBras);
    slideBtnClick('slideKnickers', slideToggle, showTabKnickers);

    ReadMore.init();
});
